import { useTranslation } from '@hooks/useTranslation';
import React, { FC, useState } from 'react';
import dynamic from 'next/dynamic';
import { useDeleteAvatar } from '@services/user/hooks/useDeleteAvatar';
import { Button } from '@components/UIKit/Button/Button';
import { useAvatarEditor } from '@hooks/useAvatarEditor';
const Modal = dynamic(import('@components/Modals/Modal').then(module => module.Modal), {
  ssr: false
});
const DeleteAvatarModal = dynamic(import('@components/Modals/Variants/DeleteAvatar/DeleteAvatar').then(module => module.DeleteAvatar), {
  ssr: false
});
interface Props {
  setDefault: ReturnType<typeof useAvatarEditor>['setDefault'];
}
export const DeleteAvatar: FC<Props> = ({
  setDefault
}) => {
  const {
    translate: tr
  } = useTranslation();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const {
    mutateAsync: deleteAvatarMutate
  } = useDeleteAvatar();
  const closeHandler = () => {
    setIsOpenModal(false);
  };
  const deleteHandler = async () => {
    await deleteAvatarMutate();
    closeHandler();
    setDefault();
  };
  return <>
            <Button id='delete_avatar_button' onClick={() => {
      setIsOpenModal(true);
    }} color='Transparent-Red' size='medium' data-sentry-element="Button" data-sentry-source-file="DeleteAvatar.tsx">
                {tr({
        id: 'btn.delete'
      })}

            </Button>
            <Modal isOpen={isOpenModal} onClose={closeHandler} data-sentry-element="Modal" data-sentry-source-file="DeleteAvatar.tsx">
                <DeleteAvatarModal closeHandler={closeHandler} deleteHandler={deleteHandler} data-sentry-element="DeleteAvatarModal" data-sentry-source-file="DeleteAvatar.tsx" />
            </Modal>

        </>;
};